/* eslint-disable react/jsx-no-undef */
import './style.scss'
import { Button, Modal } from 'antd'
import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/home'
import ArrowLeft from '@/assets/arrow-left.png'
import Empty from '@/assets/empty.png'
import { CreateVideo, Play } from '@/assets/svg'
import VideoModal from '@/components/VideoModal'
import { eventTracking, Render, urlSource } from '@/libs/util'
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons'

interface IProps {
  selectAvatar: any
  open: boolean
  onCancel: () => void
  onSelect: (avatar: any, naturalSize: any) => void
}

const AvatarModal: FC<IProps> = (props) => {
  const { open, onCancel, onSelect, selectAvatar } = props
  const { t: translate } = useTranslation(['create_video'])
  const tabs = [
    translate('create_video.my_avatars'),
    translate('create_video.public_avatars'),
    translate('create_video.my_favorites')
  ]
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [preview, setPreview] = useState<any>()
  const [openId, setOpenId] = useState<any>()
  const [data, setData] = useState<any[]>()
  const [globalData, setGlobalData] = useState<any[]>([])
  const [group, setGroup] = useState<any>()
  const [groupHumans, setGroupHumans] = useState<any[]>([])
  const [bookGroupHumans, setBookGroupHumans] = useState<any[]>([])
  const timeRef = useRef<any>()

  const showData = useMemo(() => {
    if (tabIndex === 0) {
      return data
    }
    if (tabIndex === 1) {
      return globalData
    }
    if (tabIndex === 2) {
      return bookGroupHumans
    }
  }, [tabIndex, globalData, data])

  useEffect(() => {
    if (open) {
      getData()
      getBookGroupHumans()
    } else {
      setGroup(undefined)
    }
  }, [open])

  useEffect(() => {
    if (group?.id) {
      getGroupHumans()
      loopGroupHumans()
    }
  }, [group])

  const getData = async () => {
    const [groups, globalGroups] = await Promise.all([Api.getDigitalHumanGroups(), Api.getGlobalDigitalHumanGroups()])
    setData((groups.list || []).filter((g: any) => g.member_count > 0))
    setGlobalData(globalGroups.list || [])
  }

  const getGroupHumans = async () => {
    const res = await Api.getDigitalHumansByGroup(group.id as number)
    setGroupHumans(res.list || [])
    if (!(res?.list || []).filter((d: any) => d.status === 1)?.length) {
      clearEvent()
    }
  }

  const getBookGroupHumans = async () => {
    try {
      const res = await Api.getBookmarkedCommunityHumans()
      setBookGroupHumans(
        (res?.list || []).map((l: any) => {
          return {
            cover_url: l.merchandise.id > 349 ? l.merchandise.covers[0] : l.merchandise.images[0],
            id: l.group_id,
            member_count: l.merchandise.videos.length || 0,
            title: l.merchandise.name
          }
        })
      )
    } catch {
      setBookGroupHumans([])
    }
  }

  const loopGroupHumans = () => {
    clearEvent()
    timeRef.current = setInterval(() => {
      getGroupHumans()
    }, 5000)
  }

  const clearEvent = () => {
    if (timeRef.current) {
      clearInterval(timeRef.current)
      timeRef.current = undefined
    }
  }

  const onTabChange = (index: number) => {
    if (index === 0) {
      eventTracking('MyInteractiveAvatar')
    }
    setTabIndex(index)
    setGroup(undefined)
  }

  const previeGroup = (g: any) => {
    setGroup(g)
  }

  const previewVideo = (d: any) => {
    setOpenId(undefined)
    setPreview({
      url: d.video_url_v2 || d.video_url,
      title: d.name,
      source_type: d.source_type
    })
  }

  const onBackGroups = () => {
    clearEvent()
    setGroup(undefined)
    setGroupHumans([])
    getData()
  }

  const onSelectAvatar = (avatar: any, naturalSize: any) => {
    onSelect(avatar, naturalSize)
    onCancel()
  }

  return (
    <Modal className="tab-avatar-modal" open={open} footer={null} width={1020} onCancel={onCancel}>
      <div className="tab-modal-content">
        <div className="tabs">
          {tabs.map((t, index) => (
            <div
              className={`tabs-item ${tabIndex === index ? 'actived' : ''}`}
              key={t}
              onClick={onTabChange.bind(this, index)}
            >
              <span className={tabIndex === index ? 'gradient' : ''}>{t}</span>
            </div>
          ))}
        </div>

        <div className="main">
          <div className="main-wrappper">
            {!group?.id ? (
              <>
                {showData && (
                  <>
                    {showData.length ? (
                      <div className="page-container">
                        {showData?.map((d) => (
                          <div className={`list-box ${d.id === selectAvatar?.group_id ? 'actived' : ''}`} key={d.id}>
                            <div className="box-main" onClick={() => previeGroup(d)}>
                              <div
                                className="bg"
                                style={{
                                  backgroundImage: `url(${d.cover_url})`
                                }}
                              ></div>

                              <div className="photo">
                                <img src={d.cover_url} />
                              </div>
                            </div>
                            <div className="bottom">
                              <div className="box-title">{d.title}</div>
                              {/* <div className="num">{d.member_count || 0}个形象</div> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="data-empty">
                        <img className="empty" src={Empty} />
                        <p>
                          {translate('create_video.no_avatars')}
                          {tabIndex === 0 ? (
                            <label onClick={() => window.open('/')}>{translate('create_video.go_replicate')}</label>
                          ) : (
                            <label onClick={() => window.open('/market/digital')}>
                              {translate('create_video.go_market')}
                            </label>
                          )}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <div className="common-title">
                  <img src={ArrowLeft} onClick={onBackGroups} className="arrow-left" />
                  <div className="text">{translate('create_video.video_materials')}</div>
                </div>
                <div className="page-container page-container__detail">
                  {groupHumans.map((d) => (
                    <div className={`list-box ${openId === d.id ? 'hovered' : ''} `} key={d.id}>
                      <Render>
                        {function Avatar() {
                          const [naturalSize, setNaturalSize] = useState<any>({})
                          return (
                            <>
                              <div className="box-main" onClick={() => d.status === 2 && previewVideo(d)}>
                                <div
                                  className="bg"
                                  style={{
                                    backgroundImage: `url(${urlSource(d.video_url_v2 || d.video_url, 'video')})`
                                  }}
                                ></div>

                                {d.status === 2 && (
                                  <div className="play">
                                    <Play />
                                  </div>
                                )}

                                {d.status === 1 && (
                                  <div className="mask">
                                    <div className="pending">
                                      <LoadingOutlined />
                                      <div>{translate('create_video.generating')}</div>
                                    </div>
                                  </div>
                                )}

                                {d.status === 3 && (
                                  <div className="status error">
                                    <span>{translate('create_video.generation_failed')}</span>
                                  </div>
                                )}

                                {d.id === selectAvatar?.id && (
                                  <div className="checked">
                                    <CheckOutlined />
                                  </div>
                                )}

                                <div className="photo">
                                  <img
                                    src={urlSource(d.video_url_v2 || d.video_url, 'video')}
                                    onLoad={(e: any) => {
                                      const w = e.target?.naturalWidth
                                      const h = e.target?.naturalHeight
                                      setNaturalSize({ naturalWidth: w, naturalHeight: h })
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="bottom">
                                <div className="box-title">{d.title}</div>
                                {d.status === 2 && (
                                  <Button type="primary" className="btn" onClick={() => onSelectAvatar(d, naturalSize)}>
                                    {translate('create_video.select')}
                                    <CreateVideo />
                                  </Button>
                                )}
                              </div>
                            </>
                          )
                        }}
                      </Render>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <VideoModal preview={preview} onCancel={() => setPreview(undefined)} btnShow={false} />
    </Modal>
  )
}

export default AvatarModal
